import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoginComponent } from './login.component';
import { MaterialModule } from 'src/app/core/material/material.module';
import { CardLoginComponent } from './card-login/card-login.component';
import { LogoComponent } from './card-login/logo/logo.component';
import { FormComponent } from './card-login/form/form.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxMaskModule  } from 'ngx-mask';

@NgModule({
  declarations: [
    LoginComponent,
    CardLoginComponent,
    FormComponent,
    LogoComponent
  ],
  imports: [
    CommonModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
    NgxMaskModule.forRoot()
  ]
})
export class LoginModule { }
